import React, { useEffect } from "react";
import { Layout, Typography, Divider } from "antd";
import PublicHeader from "../components/PublicHeader";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function ContactPage() {
  useEffect(() => {
    document.title = "Kontakt – Patrick Sauter – Smart Routing";
  }, []);

  return (
    <Layout style={{ minHeight: "100vh", background: "#ffffff" }}>
      <PublicHeader />
      <Content style={{ maxWidth: 900, margin: "40px auto", padding: "0 16px" }}>
        <Title level={2}>Kontakt</Title>

        <Paragraph>
          Wenn Sie Fragen zu unserer Smart-Routing-Software haben, 
          Unterstützung benötigen oder Feedback geben möchten, erreichen Sie uns unter:
        </Paragraph>

        <Paragraph>
          <b>Patrick Sauter</b><br />
          Sportplatzweg 11<br />
          72181 Starzach
        </Paragraph>

        <Paragraph>
          <b>Telefon:</b> 0157 5579 0124<br />
          <b>E-Mail:</b> info@patricksauter.de
        </Paragraph>

        <Divider />

        <Title level={3}>Support & Anfragen</Title>
        <Paragraph>
          Ich unterstütze Sie gern bei der Einrichtung und Nutzung von Smart Routing
          und helfe Ihnen bei technischen Fragen weiter. Schreiben Sie mir einfach
          eine E-Mail mit Ihrem Anliegen. Ich melde mich so schnell wie möglich bei Ihnen.
        </Paragraph>

        <Title level={3}>Feedback</Title>
        <Paragraph>
          Ihr Feedback ist uns wichtig! Teilen Sie uns mit, welche Funktionen Sie sich wünschen 
          oder wo wir uns verbessern können.
        </Paragraph>
      </Content>
    </Layout>
  );
}
